import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { MESI } from "@/lib/format";

const curMonth = () => new Date().toISOString().slice(0, 7);
const monthLabel = (ym) => (ym === "nodate" ? "Senza data" : `${MESI[Number(ym.slice(5, 7)) - 1] || ""} ${ym.slice(0, 4)}`);

export const MonthGroups = ({ items, dateOf, render, forceOpen = false, testPrefix }) => {
  const [open, setOpen] = useState({ [curMonth()]: true });
  const groups = [];
  items.forEach((it) => {
    const d = dateOf(it) || "";
    const ym = d.length >= 7 ? d.slice(0, 7) : "nodate";
    const g = groups.find((x) => x.ym === ym);
    if (g) g.items.push(it); else groups.push({ ym, items: [it] });
  });
  const cm = curMonth();
  if (!groups.some((g) => g.ym === cm)) groups.push({ ym: cm, items: [] });
  groups.sort((a, b) => (a.ym === cm ? -1 : b.ym === cm ? 1 : a.ym === "nodate" ? 1 : b.ym === "nodate" ? -1 : b.ym.localeCompare(a.ym)));
  return (
    <div className="space-y-4">
      {groups.map((g) => {
        const isOpen = forceOpen || !!open[g.ym];
        return (
          <section key={g.ym} data-testid={`${testPrefix}-month-${g.ym}`}>
            <button data-testid={`${testPrefix}-month-toggle-${g.ym}`} onClick={() => setOpen((o) => ({ ...o, [g.ym]: !isOpen }))} className="w-full flex items-center justify-between gap-3 bg-[#121824] border border-[#222D42] hover:border-[#384B6E] rounded-xl px-4 py-3 transition-colors">
              <span className="flex items-center gap-2 font-head font-semibold text-slate-100">
                {monthLabel(g.ym)}
                {g.ym === cm && <span className="text-[10px] font-medium uppercase tracking-wider text-amber-400 bg-amber-500/10 border border-amber-500/20 rounded-full px-2 py-0.5">mese in corso</span>}
              </span>
              <span className="flex items-center gap-2 text-xs text-slate-500">{g.items.length} {g.items.length === 1 ? "voce" : "voci"}<ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""}`} /></span>
            </button>
            {isOpen && (
              g.items.length === 0
                ? <p className="text-slate-600 text-sm px-4 py-4">Nessuna voce in questo mese.</p>
                : <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6 mt-4">{g.items.map(render)}</div>
            )}
          </section>
        );
      })}
    </div>
  );
};
